import { z } from 'zod';

import { IS_REQUIRED, IS_URL } from '@occc-app/lib/constants/validationMessages';

export const PushNotificationConfigSchema = z.discriminatedUnion('isEnabled', [
  z.object({
    isEnabled: z.literal(false),
  }),
  z.object({
    isEnabled: z.literal(true),
    notificationTitle: z.string().trim().optional().default(''),
    notificationBody: z.string({ required_error: IS_REQUIRED }).trim().min(1, IS_REQUIRED),
    url: z.string().url(IS_URL).nullable().optional(),
  }),
]);

export type PushNotificationConfig = z.infer<typeof PushNotificationConfigSchema>;
